import { render, staticRenderFns } from "./base-file-uploader.vue?vue&type=template&id=5f9e4c40&"
import script from "./base-file-uploader.vue?vue&type=script&lang=js&"
export * from "./base-file-uploader.vue?vue&type=script&lang=js&"
import style0 from "./base-file-uploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports